<script lang="ts">
  import { getAppConfig } from '../../../../../common/config/app-config';
  import { getStr } from '../../../../../common/util';
  import Icon from '../../Icon.svelte';
  export let isJoodDayFlag = null;
  export let joodDayRemainingQuantity = 0;
  export let variant = null;

  const { joodFullCappingLimitReached } = getAppConfig();
  const remainingQtyText = getStr('extra.joodday.availble.qty', [joodDayRemainingQuantity]); // Hardcoded 110 for now

  const backgroundImage = getStr(`extra.joodday.bottom.tag.bg.${isJoodDayFlag}`);
  const textColor = getStr(`extra.joodday.bottom.tag.color.${isJoodDayFlag}`);
  const visible = getComponentVisibility(joodFullCappingLimitReached);

  function getComponentVisibility(joodFullCappingLimitReached) {
    return joodFullCappingLimitReached !== 'true';
  }
</script>

{#if visible}
  <div
    class:pdp={variant}
    class="c_jooddayremaingqty"
    style="color: {textColor};background-image: url({backgroundImage});background-position: bottom;"
  >
    <Icon type="font" glyph="lightening" mobileSize={14} desktopSize={15} />
    {@html remainingQtyText}
  </div>
{/if}

<style lang="scss">
  .c_jooddayremaingqty {
    margin: 0;
    &.pdp {
      margin: -10px 0 4px auto;
    }
  }
  :global {
    .c_add-to-cart-popup {
      .c_jooddayremaingqty {
        &.pdp {
          margin-top: -18px !important;
        }
      }
    }
  }
</style>